import { GetStaticPaths, NextPage } from "next";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import Error500 from "pages/500";
import { useState } from "react";
import { getUserByUsername } from "services/dashboard-services";
import { revalidateCache } from "services/public-services";
import { logError } from "utils/logger";
import { BackendUsernameRegexPattern } from "utils/regex-helper";

const PublicProfile = dynamic(
  () => import("components/PublicPages/PublicProfile/PublicProfileV2"),
  {
    ssr: false,
  }
);

const PublicProfilePage: NextPage = (props: any) => {
  const router = useRouter();
  const [update, setUpdate] = useState<boolean>(false);

  const refreshData = async () => {
    try {
      await revalidateCache(props?.userData?.username);
      setUpdate(!update);
      setTimeout(() => {
        router.replace(router.asPath);
      }, 1000);
    } catch (error) {
      logError("revalidateCacheError");
    }
  };

  return props?.errorStatus === 200 ? (
    <PublicProfile
      user={props?.userData}
      refresh={refreshData}
      update={update}
    />
  ) : (
    <Error500 message={`Something Went wrong! Please try again in some time`} />
  );
};

export async function getStaticProps(ctx) {
  const username = ctx?.params?.username as string;
  const revalidateInterval = 60 * 1; // seconds (1 mins)

  const validUsername = BackendUsernameRegexPattern.test(username);
  if (!validUsername) {
    console.log("Invalid Username: ", username);
    return {
      notFound: true,
      revalidate: revalidateInterval,
    };
  }

  try {
    const response = await getUserByUsername(username);
    console.log("API Was called: ", username);
    return {
      props: {
        userData: response,
        errorStatus: 200,
      },
      revalidate: 60 * 60 * 2, // revalidate in 2 hours
    };
  } catch (error: any) {
    const errorStatus = error?.response?.status;
    console.log("User Not Found: ", username);
    if (error?.response?.status === 404) {
      return {
        notFound: true,
        revalidate: revalidateInterval,
      };
    } else {
      return {
        props: {
          errorStatus,
        },
        revalidate: revalidateInterval,
      };
    }
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export default PublicProfilePage;
